<template>
    <input ref="inputElement" v-model="value" :type="type" :name="name" />
</template>

<script setup>
import { useField } from 'vee-validate'
import { ref } from 'vue'

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    type: {
        type: String,
        default: 'text'
    },
    modelValue: {
        type: [String, Boolean],
        default: ''
    }
})

// The `name` is returned in a function because we want to make sure it stays reactive
// If the name changes you want `useField` to be able to pick it up
const { value, errorMessage } = useField(() => props.name, undefined, {
    syncVModel: true
})

const inputElement = ref(null)

// Dies ermöglicht den Zugriff auf den inputElement ref aus einer übergeordneten Komponente.
// Expose the ref to the parent
defineExpose({ inputElement })
</script>
